import { Heading, IconInfo } from "@sentricmusic/ui";
import { useTranslation } from "react-i18next";

import RebrandButtonLink from "@/components/RebrandButtonLink";

type GigsClaimHeaderProps = {
  isUpdate: boolean;
  showTourFlag: boolean;
  onStartTour: () => void;
};

function GigsClaimHeader({ isUpdate, showTourFlag, onStartTour }: GigsClaimHeaderProps) {
  const { t } = useTranslation(["gigs", "tutorial"]);

  return (
    <div className="flex items-baseline gap-5 mb-6">
      {isUpdate
        ? <Heading as="h3">{t("gigs:claim-update-header", "Update a gig claim")}</Heading>
        : <Heading as="h3">{t("gigs:claim-create-header", "Create a gig claim")}</Heading>}
      {showTourFlag && (
        <RebrandButtonLink onClick={onStartTour}>
          <div className="flex items-center gap-2 pb-1 ">
            {t("tutorial:need-help", "Need Help")}
            {" "}
            <IconInfo className="w-5 h-5 mb-1 stroke-sentric-orange" />
          </div>
        </RebrandButtonLink>
      )}
    </div>
  );
}

export default GigsClaimHeader;
